import { render, staticRenderFns } from "./watch.vue?vue&type=template&id=4564e644&scoped=true"
import script from "./watch.vue?vue&type=script&lang=js"
export * from "./watch.vue?vue&type=script&lang=js"
import style0 from "./watch.vue?vue&type=style&index=0&id=4564e644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564e644",
  null
  
)

export default component.exports